//#region IMPORT
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import UserInfoCard from '../../../../Components/Ui/UserInfoCard';
import { Button, Dialog } from '../../../../Components/MUIs';
import { Group as GroupIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import Lottie from 'lottie-react';
import AiAnimation from '../../../../Assets/animations/Loading.json';
import { useSelector } from 'react-redux';
import BackClickBottomSheetTbmEm from '../../../../Components/Ui/BackClickBottomSheetTbmEm';

//#endregion

//#region 커스텀 디자인 컴포넌트
function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      {/* 프로그레스 바 */}
      <CircularProgress
        variant="determinate"
        value={props.percentage}
        thickness={3}
        size={160}
        sx={{
          color: '#FFC2CD',
          zIndex: 1,
        }}
      />

      {/* 회색 배경 (미이수 부분) 뒤에 오버레이되게끔 둠 */}
      <CircularProgress
        variant="determinate"
        value={100}
        thickness={3}
        size={160}
        sx={{
          color: '#F0F2F3',
          position: 'absolute',
          left: 0,
          top: 0,
          zIndex: 0,
        }}
      />

      {/* 흰색 내경 배경 */}
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 115, // 내부 흰색 원의 크기 조절
          height: 115,
          backgroundColor: '#fff',
          borderRadius: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 2,
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // 그림자 추가
        }}
      />

      {/* 중앙 텍스트 및 설명 */}
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        right={0}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        zIndex={3}
      >
        <Typography sx={{ fontSize: '28px' }} fontWeight="bold">
          {`${props.percentage}`}
          <span
            style={{ color: '#828282', fontSize: '18px', fontWeight: 'bold' }}
          >
            %
          </span>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Typography variant="caption">
            <span style={{ color: '#FFC2CD', fontWeight: 'bold' }}>●</span> 이수
            시간
          </Typography>
          <Typography variant="caption">
            <span style={{ color: '#F0F2F3', fontWeight: 'bold' }}>●</span>{' '}
            미이수 시간
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
//#endregion

function M_TBM_CUSTOM_01(props) {
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { tbmMonthlyTime, tbmProgress } = useSelector((state) => state.homeInfo);

  return (
    <Box
      sx={{
        mx: 2,
        mb: 2,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <UserInfoCard
        profileImg={props.imageFile?.mapFiles}
        userInfo={props.userInfo}
        progress={{ current: 318, duration: 600 }}
        showIssuanceNotice={true}
        showButton={false}
        showProgress={false}
      />
      <Box
        sx={{
          backgroundColor: '#fff',
          borderRadius: 4,
          p: 2,
          border: 1,
          borderColor: '#F3F4F6',
        }}
      >
        <Typography fontWeight="bold" mb={2}>
          {dayjs().format('MMMM')} 교육 시간
        </Typography>

        <Box mb={2} display="flex" justifyContent="center">
          <CircularProgressWithLabel
            percentage={Math.min(
              100,
              Math.round((tbmProgress / 7200) * 100))}
          />
        </Box>

        <Typography fontSize="14px" mb={0.5}>
          총{' '}
          <span style={{ color: '#00789E', fontWeight: 'bold' }}>
            {tbmMonthlyTime / 60}
          </span>
          분 중{' '}
          <span style={{ color: '#FFB3C0', fontWeight: 'bold' }}>
            {Math.floor(tbmProgress / 60)}
          </span>
          분 이수 완료하였습니다.
        </Typography>
        <Typography fontSize="14px">
          {dayjs().format('MMMM')} TBM 이수까지{' '}
          <span style={{ fontWeight: 'bold' }}>
            {Math.max(0, (tbmMonthlyTime / 60) - Math.floor(tbmProgress / 60))}
          </span>
          분 남았습니다.
        </Typography>
      </Box>
      <Button
        sx={{
          width: '100%',
          height: '36px',
          borderRadius: '18px',
          backgroundColor: '#2CA900',
          color: '#FFFFFF',
          fontSize: '16px',
          fontWeight: '700',
        }}
        name="완료"
        onClick={() => props.setModalToggle1(true)}
      >
        완료
      </Button>
      {/* 대기 모달 */}
      {props.modalToggle1 && (
        <Dialog
          open={props.modalToggle1}
          onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  현재 입장 대기중입니다.
                </Typography>
                <Typography>잠시 대기해주세요.</Typography>
                <Typography>관리자가 교육 시작 시 진행됩니다.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 현재 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {props.userCount}명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
      {props.modalToggle2 && (
        <Dialog
          open={props.modalToggle2}
          // onClose={(e) => props.setModalToggle1(false)}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)', // 좌우 마진 고려한 전체 너비
              maxWidth: '100%', // 혹시 모를 제한 제거
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  교육이 곧 시작됩니다.
                </Typography>
                <Typography>관리자가 교육을 시작했어요.</Typography>
                <Typography>잠시 후 동영상이 자동으로 재생됩니다.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  {/* 현재 100명 중{" "} */}
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {props.userCount}명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
      {/* 바텀시트 부분 */}
      {bottomSheetState.type === 'backClickTbmEm' && (
        <BackClickBottomSheetTbmEm
          DeleteLogic1={props.DeleteLogic1}
          ActiveButton={props.ActiveButton}
        />
      )}
    </Box>
  );
}

export default M_TBM_CUSTOM_01;
